import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "my-16 lg:my-0" }, null, -1)
const _hoisted_2 = {
  class: "flex mt-20 lg:mt-28",
  "data-aos": "fade-up"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("get started ")
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"text-center flex-1 flex flex-col px-4 lg:px-0 lg:w-2/3 mx-auto mb-10 mt-16\" data-aos=\"fade-in\" data-aos-delay=\"300\"><div class=\"flex flex-col space-y-6\"><p class=\"font-display text-5xl pb-8 pt-12\">FAQ</p><p class=\"font-display text-xl\">How can I give feedback?</p><p> You can fill out <a class=\"text-palette2 underline\" href=\"https://forms.gle/KDQ5kNBJ8uCDYfdS9\">this form </a></p><p class=\"font-display text-xl\">How can I contact you?</p><p> Just send an email to <a class=\"text-palette2 underline\" href=\"mailto:jaroslawweber@gmail.com\">jaroslawweber@gmail.com</a></p></div><div class=\"my-5\"></div><hr><p class=\"pt-5\">graphics from:</p><a href=\"https://www.vecteezy.com/free-vector/cartoon\">Cartoon Vectors by Vecteezy</a></div>", 1)

import { gtag } from "@/gtag";
import { router } from "@/router";
import { isMobileScreen } from "@/screenSize";
import { store } from "@/store";
import { computed, ComputedRef, onMounted } from "vue";
import MyButton from "../components/MyButton.vue";
//import MyCard from "../components/MyCard.vue";
import HomePageTopPart from "./HomePage/HomePageTopPart.vue";
import HomePageSinglePart from "./HomePage/HomePageSinglePart.vue";
import { HomePageSection } from "@/HomePageSection";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

onMounted(() => {
  gtag.event("home");

  //page view conversion
  gtag.event("conversion", {
    send_to: `AW-967082918/4elCCOPn6_ABEKaHks0D`,
  });
});

function getStarted() {
  if (isLoggedIn.value) {
    router.push("/practice");
  } else {
    router.push("/login");
  }
}

const isLoggedIn: ComputedRef<boolean> = computed(
  () => 
  {
    let id =  store?.state?.user?.ID
    if(!id) return false
    if(id.length > 0) return true
    return false
  }
);

const isMobile = computed(() => isMobileScreen());


let section1 = new HomePageSection();
section1.title=`translate & search image`;
section1.text1 =`Flashcard software can be annoying to manage. To make a flashcard you would need to use separate website for translation. You would also need to find the image for the flashcard, download it and then upload again. Seems like a lot of trouble, right?`;
section1.text2 =`With flashi it is much simpler. Both translation and the image search in inside the app. You don't need to switch between browser tabs anymore. No more downloading an reuploading image!`;
section1.fade = `right`;
section1.classes ="bg-palette2 text-white";
section1.videoUrl =`add-word.m4v`;

let section2  =new HomePageSection()
section2.title = `long term memory`;
section2.text1 = `Flashcard software is often focusing on learning for tests and exams. You don't retain the information you learned in the long term. `
section2.text2 = `Flashi focuses on the long term memory. You still benefit in the short term. Flashi uses something called spaced repetition, which means taking breaks between practicing. It may seem slower sometimes but it is actually better if you really want to learn the language in the long term.
`
section2.classes =""
section2.fade = `left`;
section2.videoUrl = `practice.m4v`

let section3 = new HomePageSection();
section3.title = `natural sounding <br>text-to-speech`
section3.text1=`Learning a language is not only about learning how to spell a word. You need to hear the word to make stronger connection and actually know how to pronounce it.`
section3.text2=`With advanced text-to-speech technology from google, you will be confident that the pronounciation is correct. Just click one button and you will get a natural sounding audio of the word you want to learn. It is automatically played when you practice flashcard!`;
section3.classes = "bg-palette3 text-white"
section3.videoUrl =`create-audio.m4v`

let sections = [section1,section2, section3]

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(HomePageTopPart, {
      isMobile: _unref(isMobile),
      onGetStarted: _cache[0] || (_cache[0] = ($event: any) => (getStarted()))
    }, null, 8, ["isMobile"]),
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sections), (section) => {
      return (_openBlock(), _createBlock(HomePageSinglePart, {
        data: section,
        key: section.title
      }, null, 8, ["data"]))
    }), 128)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MyButton, {
        class: "px-6 mx-auto",
        onClickButton: _cache[1] || (_cache[1] = ($event: any) => (getStarted())),
        width: ""
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createVNode(_component_font_awesome_icon, {
            icon: "globe-americas",
            class: "ml-3"
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_4
  ]))
}
}

})